import { DashboardCardWrapper } from '../../../components/DashboardCardWrapper/dashboard-card-wrapper';
import { DashboardCardContentValue } from '../../../components/DashboardCardContentValue/dashboard-card-content-value';
import { RankedList } from './ranked-list';

export const RankedListWidget = ({
  to,
  title,
  value,
  unit,
  tooltip,
  rankUnit,
  loading,
  highListTitle,
  lowListTitle,
  lowListData,
  highListData,
  emptyText,
  valueSubtitle,
}: {
  to?: string;
  title: string;
  value: string;
  unit: string;
  rankUnit: string;
  tooltip?: string;
  loading?: boolean;
  highListTitle: string;
  lowListTitle: string;
  highListData: { id: string; label: string; value: number }[];
  lowListData: { id: string; label: string; value: number }[];
  emptyText?: string;
  valueSubtitle?: string;
}) => {
  return (
    <DashboardCardWrapper to={to} title={title} tooltip={tooltip} loading={loading}>
      <DashboardCardContentValue value={value} unit={unit} />
      {valueSubtitle && <p className="text-sm text-gray-400 mt-1">{valueSubtitle}</p>}
      <div className="flex flex-row gap-4 justify-between mt-6">
        <RankedList title={highListTitle} data={highListData} unit={rankUnit} lowestFirst={false} emptyText={emptyText} />
        <RankedList title={lowListTitle} data={lowListData} unit={rankUnit} lowestFirst={true} emptyText={emptyText} />
      </div>
    </DashboardCardWrapper>
  );
};
